import React from 'react'
import clsx from 'clsx'
import { renderText as defaultRenderText } from 'stream-chat-react'
import { shortenUrlLabel } from './messaging-utils'

const getLinkLabel = (children, href) => {
  if (typeof children === 'string') {
    return shortenUrlLabel(children)
  }

  if (
    Array.isArray(children) &&
    children.length === 1 &&
    typeof children[0] === 'string'
  ) {
    return shortenUrlLabel(children[0])
  }

  return shortenUrlLabel(href || '')
}

const MessagingAnchor = ({ children, href }) => {
  const isEmail = href?.startsWith('mailto:')
  const isUrl = href?.startsWith('http')

  if (!href || (!isEmail && !isUrl)) {
    return <>{children}</>
  }

  const fullLabel =
    typeof children === 'string'
      ? children
      : Array.isArray(children) && typeof children[0] === 'string'
        ? children[0]
        : href

  return (
    <a
      className={clsx({ 'str-chat__message-url-link': isUrl })}
      href={href}
      rel="nofollow noreferrer noopener"
      target="_blank"
      title={fullLabel}
    >
      {isUrl ? getLinkLabel(children, href) : children}
    </a>
  )
}

export const messagingRenderText = (text, mentionedUsers, options = {}) =>
  defaultRenderText(text, mentionedUsers, {
    ...options,
    customMarkDownRenderers: {
      ...options.customMarkDownRenderers,
      a: MessagingAnchor,
    },
  })
